import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const CardActions = ({ canSign }) => {
    const { t } = useTranslation();

    return (
        <div className="card-actions">
            <Link to="signDocument" className={`btn-medium btn-primary ${!canSign ? 'disable-link' : ''}`}>
                {t('cardActions.signButton')}
            </Link>
        </div>
    );
};
